export type ColorInfoBoxType = 'blue' | 'red' | 'green' | 'black' | 'orange' | 'gray';
